module.exports = __webpack_public_path__ + "img/sponsor_gallery_grid5.21d18675.png";